export default __webpack_public_path__ + "static/media/smiley_6.2933c6f9.svg";